// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GoodsAdd_wrap__VMMg1"};